import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const BreakdownSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#002077',
        py: { xs: 2, xxl: 6 },
        px: 2,
        textAlign: 'center'
      }}
    >
        <Box
            sx={{
                width: { xs: "100%", xxl: "70%" },
                margin: "0 auto"
            }}
        >
            <Typography
              variant="h2"
              sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: "20px", xxl: "36px" },
                  color: '#fff',
                  mb: {xs: 2, xxl: 4}
              }}
              >
              Lorem ipsum dolor sit amet.
            </Typography>

            <Typography
                variant="subtitle1"
                sx={{
                    color: '#fff',
                    fontWeight: 500, 
                    fontSize: { xs: "14px", xxl: "21px" }, 
                    lineHeight: "28px", 
                    letterSpacing: "normal", 
                    mb: { xs: 2, xxl: 4 }
                }}
            >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </Typography>


            {/* Pricing Rows */}
            {[
              { text: 'Lorem ipsum dolor sit amet', price: '400 lei' },
              { text: 'Lorem ipsum dolor sit amet', price: '1600 lei' },
              { text: 'Lorem ipsum dolor sit amet', price: '700 lei' },
              { text: 'Lorem ipsum dolor sit amet', price: '800 lei' },
            ].map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#0A2D9E',
                  borderRadius: "16px",
                  px: 4,
                  py: 2,
                  mb: 2,
                  mx: 'auto',
                  color: '#fff',
                  
                }}
              >
                <Box sx={{ textAlign: 'left' }}>
                  <Typography sx={{ fontWeight: 700, fontSize: { xs: "14px", xxl: "21px" } }}>{item.text}</Typography>
                  <Typography sx={{ fontSize: { xs: "12px", xxl: "18px" } }}>
                    consectetur adipiscing elit, sed do eiusmod
                  </Typography>
                </Box>
                <Typography sx={{ fontWeight: 700, color: '#20defa', fontSize: { xs: "20px", xxl: "36px" } }}>
                  {item.price}
                </Typography>
              </Box>
            ))}

            {/* Total and Special Price */}
            <Box sx={{ mt: 4 }}>
              <Typography
                sx={{
                  textDecoration: 'line-through',
                  fontWeight: 500,
                  fontSize: { xs: "14px", xxl: "21px" },
                  color: '#20defa'
                }}
              >
                Valoare totala: 3800 lei
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "20px", xxl: "36px" },
                  fontWeight: 700,
                  mt: 1,
                  color: '#20defa'
                }}
              >
                Pretul tau: <span style={{ color: '#fff' }}>500 lei</span>
              </Typography>
            </Box>
        </Box>

        <Button
            variant="contained"
            fullWidth={false}
            href="#"
            sx={{
            mt: { xs: 2, xxl: 4 },
            px: { xs: 2, sm: 4 },
            py: { xs: 0, sm: 2 },
            color: "#002077",
            backgroundColor: "#fff",
            borderRadius: "16px",
            textTransform: "none",
            fontWeight: "700", 
            fontSize: { xs: "16px", xxl: "20px" }, 
            lineHeight: "14px",
            letterSpacing: "normal",
            "&:hover": {
                backgroundColor: "#20defa",
                color: "#fff",
            },
            }}
        >
            Download resource
        </Button>
    </Box>
  );
};

export default BreakdownSection;